// MaxAlcoholCard.tsx
import React from "react";
import infoIcon from "../../../assets/images/info.png";

type Props = {
  amount: number; // e.g. 1660
  title?: string; // default: "Max Alcohol Provided"
  note?: string; // default: "This may not be the final spend on alcohol"
  disclaimer?: string; // default: "This does not include the platform fee and taxes."
  currency?: string; // default: "USD"
  className?: string;
};

const fmt = (n: number, currency = "USD") =>
  n.toLocaleString(undefined, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  });

export default function MaxAlcoholCard({
  amount,
  title = "Total Alcohol",
  note = "",
//   disclaimer = "This does not include the platform fee and taxes.",
  disclaimer = "This does not include the sales taxes.",
  currency = "USD",
  className = "",
}: Props) {
  return (
    <div className={["w-full", className].join(" ")}>
      {/* pill card */}
      <div className="w-full rounded-2xl bg-gray-50 px-4 py-3 sm:px-5 sm:py-4 ring-1 ring-gray-100">
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm font-[400] text-[#19191C]">{title}</p>
          <p className="text-sm font-[400] text-[#19191C]">
            {fmt(amount, currency)}
          </p>
        </div>

        {/* info line */}
        <div className="mt-2 flex items-start gap-2 text-xs text-gray-500">
          {/* <InfoIcon /> */}
          <span className="font-[400] text-[10px] text-[#8D8D8D]">{note}</span>
        </div>
      </div>

      {/* disclaimer */}
      <p className="mt-1 pl-2 text-[11px] text-orange-600">{disclaimer}</p>
    </div>
  );
}

function InfoIcon() {
  return <img src={infoIcon} className="w-4 h-4" alt="" />;
}
